import { BaseDto } from './base.dto';

export class ProductOutOfStockDto extends BaseDto {
  menuId: number;
  merchantId: number;
  productName?: string;
  productId: number;
  isOutOfStock: boolean;
  remaining: number;
  menusToInclude?: number[];
}
